import BaseSallaForm from './BaseSallaForm';

const SallaPrivateAppForm = () => (
	<BaseSallaForm
		showUsername
		showWarehouse
		showCredentials
		copyStoreName
		copyBaseUrl
		showCallbackUrl
		advanceSettingsFields={['addHour']}
	/>
);

export default SallaPrivateAppForm;
